import { NavBar } from "@finanedi.es/storybook"
import CustomButton from "common/components/Button/Button"
import FormikPassword from "common/components/FormikFields/FormikPassword"
import NavBarChildren from "common/components/NavBar"
import {
  validatePassword,
  validateRepeatPassword,
} from "common/utils/formValidations"
import {
  resetPassword,
  userSelector,
} from "features/User/redux/slices/userSlice"
import { Form, Formik } from "formik"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import * as Yup from "yup"
import "./recoveryPassword.scss"

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    password: validatePassword(t),
    repeatPassword: validateRepeatPassword(t),
  })

const initialValues = {
  password: "",
  repeatPassword: "",
}

const RecoveryPasswordStep2 = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const location = useLocation()
  const { loadingResetPassword } = useSelector(userSelector)

  const onSubmit = ({ password }: $TSMigrationFixMe) => {
    const params = new URLSearchParams(location.search)
    const userId = params.get("user")
    // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable...
    const token = encodeURIComponent(params.get("token"))

    // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
    dispatch(resetPassword({ password, token, userId }))
  }

  return (
    <div className='container text-left form-recovery-password'>
      <NavBar classNameNavBar='!tw-w-full !tw-flex-grow-0 tw-shadow-md tw-min-h-5 tw-h-16 tw-flex tw-items-center tw-p-0.5 tw-z-0 tw-bg-primary tw-order-last'>
        <NavBarChildren
          secondary
          hideRegis
        />
      </NavBar>
      <h5>{t("recoveryPasword.title")}</h5>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema(t)}
      >
        <Form className='p-fluid'>
          <div className='mt-4 p-field'>
            <label htmlFor='password'>
              {t("recoveryPasword.passwordLabel")}
            </label>

            <FormikPassword
              autoFocus
              name='password'
              id='password'
            />
          </div>

          <div className='p-field'>
            <label htmlFor='repeatPassword'>
              {t("recoveryPasword.repeatPasswordLabel")}
            </label>

            <FormikPassword
              feedback={false}
              name='repeatPassword'
              id='repeatPassword'
            />
          </div>

          <CustomButton
            loading={loadingResetPassword}
            label={t("recoveryPasword.changePasswordButton")}
            className='!tw-bg-primary'
            type='submit'
          />
        </Form>
      </Formik>
    </div>
  )
}

export default RecoveryPasswordStep2
